import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';

import { userPermissions, urlApplicationRoot } from '/business/shared/util/Statics';

import getApplicationDealershipNameSelector from '/business/shared/state/selectors/application/model/getApplicationDealershipNameSelector';
import getApplicationAuthRuleSelector from '/business/shared/state/selectors/auth/getApplicationAuthRuleSelector';
import isGettingStartedPageHiddenSelector from '/business/shared/state/selectors/application/workflow/isGettingStartedPageHiddenSelector';

import HeaderApplicationSubNavMenu from './HeaderApplicationSubNavMenu';
import HeaderApplicationMetavalue from './HeaderApplicationMetavalue';
import HeaderApplicationTabs from './HeaderApplicationTabs';

import StyledHeaderApplication from '/business/shared/components/widgets/header/__styled__/StyledHeaderApplication';
import useAppContext from '/business/shared/hooks/useAppContext';
import type { RootState } from '/business/shared/state/store';

function HeaderApplication() {
  const dealershipName = useSelector(getApplicationDealershipNameSelector);
  const hasStateSelectorAuth =
    useSelector((state: RootState) =>
      getApplicationAuthRuleSelector(state, userPermissions.VIEW_APPLICATION_STATE_SELECTOR),
    ) || false;
  const isGettingStartedPageHidden = useSelector(isGettingStartedPageHiddenSelector) || true;

  const { t } = useTranslation();
  const { getFlattenedQuestions } = useAppContext();
  const questions = getFlattenedQuestions?.() ?? [];
  const location = useLocation();
  const path = location.pathname;

  if (path.startsWith(`/${urlApplicationRoot}/debug-transition-application`)) {
    return null;
  }
  return (
    <>
      <HeaderApplicationSubNavMenu />
      <StyledHeaderApplication
        $isGettingStartedPageHidden={isGettingStartedPageHidden}
        $hasStateSelectorAuth={hasStateSelectorAuth}
      >
        <HeaderApplicationMetavalue
          label={t('business:ApplicationInputs.dealershipName', 'Name')}
          value={dealershipName}
        />
      </StyledHeaderApplication>
      {isGettingStartedPageHidden && <HeaderApplicationTabs questions={questions} />}
    </>
  );
}

export default HeaderApplication;
